import React from 'react';

interface IProps {
    children?: any;
}

/**
 * @description The title of the table. 
 * Place above the component HanTable if you want a full-width title which does not scroll with the table.
 * Place inside the componentn HanTable if you want a one column sized title.
 * @param children The title of the table. Placed inside a p-tag.
 */
const HanTableHead: React.FC<IProps> = ({ children }) => {
    return (
        <div className="han-table__head">
            <p className="han-table__title">
                {children}
            </p>
        </div>
    )
}

export default HanTableHead;
